<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
        <div class="my-account-title">Login Information</div>
        <div class="col-lg-12" style="padding-top: 10px">
            <p class="error-message" v-if="LoginErrorMessage">{{LoginErrorMessage}}</p>
        </div>
        <div class="account_section_box">
            <div class="row">
                <div class="col-lg-4">
                    <label>Email Address:</label>
                </div>
                <div class="col-lg-8">
                    <div id="AccountEmailAddress" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group" v-show="LoginFormInputs.EmailAddress">
                            <label>New Email Address</label>
                            <input v-on:blur="ValidateEmail()" v-bind:class="{ error_field: LoginValidationResult.AccountEmailAddress }" v-model="LoginEdit.emailAddress" type="email" class="form-control input_field" oninput="this.value = this.value.toLowerCase()">
                            <p class="error-message" v-if="LoginValidationResult.AccountEmailAddress">{{LoginValidationResult.AccountEmailAddress}}</p>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group" v-show="LoginFormInputs.EmailAddressConfirm">
                            <label>Confirm Email Address</label>
                            <input v-on:blur="ValidateConfirmEmail()" v-bind:class="{ error_field: LoginValidationResult.AccountEmailAddressConfirm }" v-model="LoginEdit.emailAddressConfirm" type="email" class="form-control input_field" oninput="this.value = this.value.toLowerCase()">
                            <p class="error-message" v-if="LoginValidationResult.AccountEmailAddressConfirm">{{LoginValidationResult.AccountEmailAddressConfirm}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <label>Password:</label>
                </div>
                <div class="col-lg-8">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group" v-show="LoginFormInputs.NewPassword">
                            <label>New Password</label>
                            <input v-on:keyup="CheckPasswordDigits();" 
                            v-bind:class="{ error_field: LoginValidationResult.AccountPassword, error_field2: hasPasswordError }" 
                            v-model="LoginEdit.newPassword" type="password" class="form-control input_field">
                            <p class="error-message" v-if="LoginValidationResult.AccountPassword">{{LoginValidationResult.AccountPassword}}</p>
                            <!-- REAL TIME VALIDATION -->
                            <p v-else-if="hasPasswordError && !LoginValidationResult.AccountPassword" class="error-message">{{hasPasswordErrorMessage}}</p>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group" v-show="LoginFormInputs.NewPasswordConfirm">
                            <label>Confirm New Password</label>
                            <input v-on:keyup="CheckConfirmPasswordDigits();" 
                            v-bind:class="{ error_field: LoginValidationResult.AccountPasswordConfirm, error_field2: hasConfirmPasswordError }" 
                            v-model="LoginEdit.newPasswordConfirm" type="password" class="form-control input_field">
                            <p class="error-message" v-if="LoginValidationResult.AccountPasswordConfirm">{{LoginValidationResult.AccountPasswordConfirm}}</p>
                            <!-- REAL TIME VALIDATION -->
                            <p v-if="hasConfirmPasswordError && !LoginValidationResult.AccountPasswordConfirm" class="error-message">{{hasConfirmPasswordErrorMessage}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="background-color: whitesmoke; padding-top: 15px">
                <div class="col-lg-4">
                    <label>Current Password*
                        <span data-balloon="To change your email or password enter your existing password in the Current Password field." data-balloon-pos="up" data-balloon-length="large">
                            <i class="fa fa-question-circle-o"></i>
                        </span>
                    </label>
                </div>
                <div class="col-lg-8">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group" v-show="LoginFormInputs.Password">
                            <input v-on:keyup="CheckMatchCurrentPassword()"
                            v-bind:class="{ error_field: LoginValidationResult.OldAccountPassword }" v-model="LoginEdit.password" type="password" class="form-control input_field">
                            <p class="error-message" v-if="LoginValidationResult.OldAccountPassword">{{LoginValidationResult.OldAccountPassword}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        "LoginValidationResult",
        "LoginFormInputs",
        "LoginEdit",
        "LoginErrorMessage"
    ],
    data() {
        return {
            hasPasswordError: false,
            hasConfirmPasswordError: false,
            hasPasswordErrorMessage: '',
            hasConfirmPasswordErrorMessage: ''
        }
    },
    methods: {
        CheckPasswordDigits() {
            if(this.LoginEdit.newPassword == null || this.LoginEdit.newPassword == ''){
                this.hasPasswordError = false;
                this.hasPasswordErrorMessage = '';
            }
            else{
                var result = this.G_CheckPasswordDigits(this.LoginEdit.newPassword);
                if(result) {
                    this.hasPasswordError = result.error;
                    this.hasPasswordErrorMessage = result.message;
                }
                this.CheckMatchPassword();
                this.CheckMatchCurrentPassword();
            }
        },
        CheckConfirmPasswordDigits() {
            if(this.LoginEdit.newPasswordConfirm == null || this.LoginEdit.newPasswordConfirm == ''){
                this.hasConfirmPasswordError = false;
                this.hasConfirmPasswordErrorMessage = '';
            }
            else {
                var result = this.G_CheckPasswordDigits(this.LoginEdit.newPasswordConfirm);
                if(result) {
                    this.hasConfirmPasswordError = result.error;
                    this.hasConfirmPasswordErrorMessage = result.message;
                }
                this.CheckMatchPassword();
                this.CheckMatchCurrentPassword();
            }
           
        },
        CheckMatchPassword() {
            var result = this.G_CheckMatchPassword(this.LoginEdit.newPassword, this.LoginEdit.newPasswordConfirm);
            if(result.length != 0) {
                this.hasPasswordError = result[0].error;
                this.hasPasswordErrorMessage = result[0].message;
                this.hasConfirmPasswordError = result[1].error;
                this.hasConfirmPasswordErrorMessage = result[1].message;
            }
        },
        CheckMatchCurrentPassword() {
            var result1 = this.G_CheckMatchCurrentPassword(this.LoginEdit.password, this.LoginEdit.newPassword);
            var result2 = this.G_CheckMatchCurrentPassword(this.LoginEdit.password, this.LoginEdit.newPasswordConfirm);
            if(result1) {
                this.hasPasswordError = result1.error;
                this.hasPasswordErrorMessage = result1.message;
            }
            if(result2) {
                this.hasConfirmPasswordError = result2.error;
                this.hasConfirmPasswordErrorMessage = result2.message;
            }
        },
        ValidateEmail() {
            this.$emit("ValidateEmail");
        },
        ValidateConfirmEmail(){
            this.$emit("confirmEmail");
        }
    },
    created() {
        this.LoginValidationResult = {}
    }
};
</script>


// WEBPACK FOOTER //
// EditLoginInfo.vue?5b37a272